VjsAdmin.regexPlayground = (function () {
    const me = {};
    const districtGuid = $('.district-info').data('district-guid');
    const platform = $('.platform-info').data('platform-id');
    const init = function () {
        new PlaygroundClickEvent();
    };
    me.orgUnitItems = [];
    me.originalRegexElement = '';

    const PlaygroundClickEvent = VjsUtility.Controller.extend({
        events: {
            'click .playground-direct-mapping': 'clickPlaygroundDirectMappingBtn',
            'click .add-to-mapping': 'clickAddRegex',
            'click .cancel-playground': 'clickCancelPlayground',
            'keyup .regex-value': 'changeRegexValue',
        },
        clickAddRegex() {
            $(me.originalRegexElement).val($('.regex-value').val());
            VjsUtility.Popup.close();
        },
        clickCancelPlayground() {
            VjsUtility.Popup.close();
        },
        clickPlaygroundDirectMappingBtn(e) {
            me.originalRegexElement = $(e.currentTarget).closest('.direct-mapping-component').find('.orgunit-name');
            const oldRegexValue = $(e.currentTarget).closest('.direct-mapping-component').find('.orgunit-name').val();
            VjsUtility.Popup.init({
                title: 'Regex Playground',
                templateUrl: '/assets/templates/google/mapping/regex-playground.html',
                after() {
                    $('.regex-value').val(oldRegexValue);
                    new PlaygroundClickEvent();
                    const orgUnitView = new PlaygroundOrgUnitView();
                    orgUnitView.fetch({
                        included_only: true,
                    });
                },
            });
        },
        changeRegexValue(e) {
            const regexValue = $(e.currentTarget).val();
            regexHighlightTest(regexValue);
        },
    });

    const PlaygroundOrgUnitView = VjsUtility.View.extend({
        parent: '.org-unit-view',
        templateUrl: '/assets/templates/google/mapping/playground-orgunit-component.html',
        dataUrl: `/platforms/${platform}/districts/${districtGuid}/google/orgunit-mapping/`,
        after() {
            // Capture org unit paths as plain text from the API response data.
            // Encoding happens at the sink in regexHighlightTest so the protection
            // is explicit and does not rely on the Handlebars {{ }} upstream invariant.
            me.orgUnitItems = (this.responseData || []).map(function (item) {
                return item.orgUnitPath || '';
            });
            const regexValue = $('.regex-value').val();
            regexHighlightTest(regexValue);
        },
    });

    function regexHighlightTest(regex) {
        // NOTE: this function no longer reads or writes the captured innerHTML of
        // .playground-orgunit-component. It rebuilds the <li> list from the plain-text
        // me.orgUnitItems array, encoding each item at the sink. The only intentional
        // HTML in the output is the <mark> wrapper added by the regex replace.
        // Cross-<li>-boundary matching (which the previous implementation supported via
        // a whitespace-to-HTML-tag regex substitution) is intentionally dropped: each
        // org-unit path is matched independently, which is the correct semantic.
        const $list = $('.playground-orgunit-component').find('ul');
        if (!$list.length || !me.orgUnitItems.length) {
            return;
        }

        let pattern = null;
        if (regex !== '') {
            try {
                pattern = new RegExp(`(${regex})`, 'gi');
            } catch (e) {
                // Invalid regex (e.g. unclosed paren while typing) — render without highlights.
                pattern = null;
            }
        }

        const $items = me.orgUnitItems.map(function (text) {
            const encoded = SafeDOM.escapeHtml(text);
            const highlighted = pattern
                ? encoded.replace(pattern, '<mark>$1</mark>')
                : encoded;
            return $('<li>').html(highlighted);
        });

        $list.empty().append($items);
    }

    return {
        init,
    };
}());
